import { useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { errMsg } from "@/lib/api";

export const EXIT_REASONS = [["too_expensive", "Too expensive"], ["no_time", "Not enough time to use it"], ["not_found", "Didn't find what I needed"], ["not_now", "Not the right time"], ["other", "Something else"]];

export const ExitQuestion = ({ onSubmit, onDone }) => {
  const [reason, setReason] = useState("");
  const [comment, setComment] = useState("");
  const [busy, setBusy] = useState(false);
  const send = async () => {
    setBusy(true);
    try { await onSubmit({ reason, comment }); onDone(); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div className="space-y-4" data-testid="exit-question">
      <div className="flex flex-wrap gap-2">{EXIT_REASONS.map(([k, label]) => (
        <button key={k} type="button" onClick={() => setReason(k)} aria-pressed={reason === k} data-testid={`exit-reason-${k}`}
          className={`rounded-full border-2 px-4 py-2 text-sm transition-colors ${reason === k ? "border-pinkb bg-pinkb/10 text-navy" : "border-border bg-white hover:border-pinkb/50"}`}>{label}</button>
      ))}</div>
      {reason && <Textarea value={comment} onChange={(e) => setComment(e.target.value.slice(0, 1000))} rows={3} placeholder="Anything else you'd like Lindsay to know? (optional)" data-testid="exit-comment" className="bg-white fade-up" />}
      <Button type="button" onClick={send} disabled={!reason || busy} data-testid="exit-submit" className="rounded-full bg-pinkb hover:bg-pinkb/90 text-white">
        {busy && <Loader2 className="h-4 w-4 mr-2 animate-spin" />}Send to Lindsay
      </Button>
    </div>
  );
};
